'use client';
import Script from 'next/script';
import { useEffect } from 'react';

type Props = {
  cmId: string;
};

export const TrustArcScript = ({ cmId }: Props) => {
  useEffect(() => {
    // need to do this in useEffect instead of inline to ensure no hydration errors
    const script = document.createElement('script');
    script.src = `https://consent.trustarc.com/v2/notice/${cmId}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [cmId]);

  return (
    <>
      <Script
        strategy="beforeInteractive"
        src={`https://consent.trustarc.com/v2/autoblockasset/core.min.js?cmId=${cmId}`}
      ></Script>
      <Script
        strategy="beforeInteractive"
        src={`https://consent.trustarc.com/v2/autoblock?cmId=${cmId}`}
      ></Script>
    </>
  );
};
